import { useMemo } from "react"
import _ from "lodash"

import { useSponsoredContent } from "./useSponsoredContent"
import { IRecord } from "interfaces"
import { ImdfFeature } from "providers/venue/types"

interface ISponsorContentConfig {
  disable?: boolean
  limit?: number
  frequency?: number
}

interface IUseSponsoredSearchResult {
  searchResults: (IRecord | ImdfFeature)[]
  searchResultConfig: ISponsorContentConfig
}
export const useSponsoredSearchResult = (): IUseSponsoredSearchResult => {
  const { searchResult } = useSponsoredContent()

  const searchResultConfig = useMemo(
    () => _.get(searchResult, "config"),
    [searchResult]
  )

  const searchResults = useMemo(
    () => _.get(searchResult, "data", []),
    [searchResult]
  )

  return {
    searchResults,
    searchResultConfig,
  }
}
